import t from "./highrise1460.mjs";
import i from "./highrise1461.mjs";
function e(r) {
  return r != null && i(r.length) && !t(r);
}
export {
  e as default
};
